import Logo1 from '../../assets/basket.jpg';
import Logo2 from '../../assets/klasik.jpg';
import Logo3 from '../../assets/atletika.jpg';


const Teams = () => {
    return (
        <div className="bg-ink-100 border-t border-ink-200 py-12 md:py-16">
            <div className="container-narrow section text-center">
                <span className="badge-brand mb-3">Spolupracujeme</span>
                <h2 className="text-2xl md:text-3xl font-bold text-ink-900">Naši partneři</h2>
                <div className="mt-3 flex justify-center"><span className="accent-bar" /></div>

                <div className="mt-10 grid grid-cols-[1fr_auto_1fr] items-center gap-8 md:gap-20">
                    <img src={Logo2} alt="Klasik Frýdek-Místek" loading="lazy" className="justify-self-end h-24 md:h-32 object-contain opacity-80 hover:opacity-100 transition-opacity" />
                    <img src={Logo1} alt="Basketbal Frýdek-Místek" loading="lazy" className="justify-self-center h-24 md:h-32 object-contain opacity-80 hover:opacity-100 transition-opacity" />
                    <img src={Logo3} alt="Atletika Frýdek-Místek" loading="lazy" className="justify-self-start h-24 md:h-32 object-contain opacity-80 hover:opacity-100 transition-opacity" />
                </div>
            </div>
        </div>
    );
};

export default Teams;
